module.exports = __webpack_public_path__ + "7004d53eaff0ed15bc5076968e0966a9.pdf";